import { PodeNaoPodeEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { ConsultaSeguimentoAplicacaoItemModel } from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export enum ConsultaSeguimentoPergunta18ExemplosEnum {
  SEM_DICA_MOSTRA_SAPATO = 'SEM_DICA_MOSTRA_SAPATO',
  SEM_DICA_TRAZ_COBERTOR = 'SEM_DICA_TRAZ_COBERTOR',
  SEM_DICA_POE_LIVRO_CADEIRA = 'SEM_DICA_POE_LIVRO_CADEIRA',
}

export interface ConsultaSeguimentoPergunta18Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_18_HEADER?: SimNaoEnum
  PERGUNTA_18_PODE_NAO_PODE?: PodeNaoPodeEnum
  PERGUNTA_18_TEM_DICA_SEGUE_ORDEM?: SimNaoEnum
  PERGUNTA_18_SENTA_A_MESA?: SimNaoEnum
  PERGUNTA_18_EXEMPLOS?: Record<ConsultaSeguimentoPergunta18ExemplosEnum, SimNaoEnum | undefined>
}
